import type { FunctionComponent } from "react";
import { StyledInfoButton } from "./InfoIconButtonStyle";
import type { IconNames } from "@smartsuite/icons";
import { Icon, SolutionColorVariables } from "@smartsuite/react-ui";

interface InfoIconButtonProps {
  iconName: IconNames;
  onClick?: () => void;
}

export const InfoIconButton: FunctionComponent<InfoIconButtonProps> = ({
  iconName,
  onClick,
}) => {
  return (
    <StyledInfoButton onClick={onClick} role="button">
      <Icon color={SolutionColorVariables.sc1} name={iconName} />
    </StyledInfoButton>
  );
};
